type Props = React.ImgHTMLAttributes<HTMLImageElement>;

export const AppImage = (props: Props): JSX.Element => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};
